import { OxsUserRole } from '@openx/types/user.ts';
import type { TFunction } from 'i18next';

export const getUserRolelables = (t: TFunction) => ({
  [OxsUserRole.ADMIN]: t('Admin'),
  [OxsUserRole.MANAGER]: t('Manager'),
  [OxsUserRole.MEMBER]: t('Member'),
});

export const getUserRoleDescriptions = (t: TFunction) => ({
  [OxsUserRole.ADMIN]: t(
    'Full access to all organizations, users, settings, and commercial configuration. For internal users only.'
  ),
  [OxsUserRole.MANAGER]: t('Full access to manage users, organization settings, inventory, data, deals, and reports.'),
  [OxsUserRole.MEMBER]: t(
    'Operational access to deals, inventory, and data within their own organization, without managing users or organization details.'
  ),
});
